<template>
  <template v-if="!getGuideValue">
    <div v-if="isAuthLoading">
      <!-- 로딩 중일 때 표시할 내용 -->
      <div class="loading-container">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <template v-else>
      <div v-if="$route.path.indexOf('/guide') != -1">
        <GuideMainView></GuideMainView>
      </div>
      <router-view name="login"></router-view>
      <router-view name="main"></router-view>
      <router-view name="test"></router-view>
      <Teleport to="body">
        <GmxToast ref="toastRef"></GmxToast>
        <GmxConfirm ref="confirmRef"></GmxConfirm>
        <GmxAlert ref="alertRef"></GmxAlert>
        <!-- SSE 연결 모니터 (개발 환경에서만 표시) -->
        <SSEConnectionMonitor />
      </Teleport>
    </template>
  </template>
  <template v-else>
    <guidePage></guidePage>
  </template>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import GuideMainView from "@/views/guide/layout/MainView.vue";
import guidePage from "./guidePage.vue";
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { GmxAlert, GmxConfirm, GmxToast } from './components/gmx';
import SSEConnectionMonitor from '@/components/ezone/sse/SSEConnectionMonitor.vue';

const getGuideValue = process.env.VUE_APP_GUIDE == 'true';
const store = useStore();
const route = useRoute();
const toastRef = ref('toastRef');
const confirmRef = ref('confirmRef');
const alertRef = ref('alertRef');
const isAuthLoading = ref(true);

// store에서 userId를 가져오는 computed
const userId = computed(() => store.getters['systemInfo/getUserId']);

const initializeAuth = async () => {
  try {
    // main.js에서 이미 사용자 데이터가 복원되었으므로 여기서는 단순히 로딩 완료 처리
    console.log('📋 App.vue: Auth initialization completed');
  } catch (error) {
    console.error('권한 정보 확인 실패:', error);
  } finally {
    isAuthLoading.value = false;
  }
};

// SSE 연결 체크 함수
const checkAndConnectSSE = () => {
  const isEzonePage = route.path.includes('/ezone');
  const isSSEConnected = store.getters['sse/isConnected'];
  
  if (userId.value && isEzonePage && !isSSEConnected) {
    console.log('🔗 Starting SSE connection for ezone page...');
    setTimeout(() => {
      store.dispatch('sse/connect').catch(error => {
    
        console.warn('SSE 연결 실패:', error.message);
      });
    }, 1000);
  } else if (!userId.value) {
    console.log('ℹ️ No user logged in, skipping SSE connection');
  } else if (!isEzonePage) {
    console.log('ℹ️ Not on ezone page, skipping SSE connection');
  } else if (isSSEConnected) {
    console.log('ℹ️ SSE already connected');
  }
};

onMounted(async () => {
  if (!getGuideValue) {
    store.commit('gmxCommon/initRef', {key:'toast', ref:toastRef});
    store.commit('gmxCommon/initRef', {key:'confirm', ref:confirmRef});
    store.commit('gmxCommon/initRef', {key:'alert', ref:alertRef});
    
    // 권한 정보 초기화
    await initializeAuth();
    
    // SSE 연결은 라우트 변경 시 체크
    checkAndConnectSSE();
  }
});

// 라우트 변경 감지하여 SSE 연결 체크
watch(() => route.path, () => {
  checkAndConnectSSE();
}, { immediate: false });
</script>

<style lang="scss">
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9999;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
